import { render } from "./my-collection.vue?vue&type=template&id=9de89cea&scoped=true&ts=true"
import script from "./my-collection.vue?vue&type=script&lang=ts"
export * from "./my-collection.vue?vue&type=script&lang=ts"

import "./my-collection.vue?vue&type=style&index=0&id=9de89cea&lang=sass&scoped=true"

import exportComponent from "/Users/ohirjak/projects/mov-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9de89cea"]])

export default __exports__